'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventGroupRoutes = [
  {
    path: 'groups',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.group.list',
        props: true,
        component: () => import('../views/GroupListView.vue'),
      },
      // {
      //   path: ':groupId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.group.detail',
      //       component: () => import('../views/GroupDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageGroupRoutes = [
  {
    path: 'groups',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.group.list',
        props: true,
        component: () => import('../views/ManageGroupListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.group.add',
        props: true,
        component: () => import('../views/ManageGroupAddView.vue'),
      },
      {
        path: ':groupId',
        component: EmptyRouterView,
        props: true,
        children: [
          // {
          //   path: '',
          //   name: 'event.manage.group.detail',
          //   props: true,
          //   component: () => import('../views/ManageGroupDetailView.vue'),
          // },
          {
            path: 'edit',
            name: 'event.manage.group.edit',
            props: true,
            component: () => import('../views/ManageGroupEditView.vue'),
          },
        ],
      },
    ],
  },
];
